import axiosInstance from "./AxiosInstance";

const userUrl = "api/users"

export function CreateUser(data) { 
    return axiosInstance.post(`${userUrl}/user`, data)
}

export function ImportUserDataAPI(file) {
    return axiosInstance.post(`${userUrl}/import_user`, file, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function getUserList(page, page_size, filter = {}) {
  const params = new URLSearchParams({
    page,
    page_size,
    ...filter,
  });

  return axiosInstance.get(`${userUrl}/user?${params.toString()}`);
}

export function exportUserList(filter = {}) {
  const params = new URLSearchParams({
    export: "true",  // 👈 used to trigger Excel response
    ...filter,
  });

  return axiosInstance.get(`${userUrl}/user?${params.toString()}`, {
    responseType: "blob",  // 👈 crucial for downloading Excel files
  });
}

export function updateUser(userId, data) {
    return axiosInstance.put(`${userUrl}/user/${userId}`, data);
}


export function searhAreaByLocationApi(loactionId){
    return axiosInstance.get(`api/search/area-by-location/${loactionId}`)
}
export function searchLocation(param={}) {
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/search/location?${fparam}`);
}
export function searchDepartment(loactionId, query='') {
    return axiosInstance.get(`api/search/department/${loactionId}?query=${query}`);
}
export function searchDesignation(query) {
    return axiosInstance.get(`api/search/designation?query=${query}`);
}

export function getUserById(userId) {
  return axiosInstance.get(`${userUrl}/userdetails/${userId}`);
}

export function getUserByLocation(locationId, query='') {
  return axiosInstance.get(`api/search/user-by-location/${locationId}?query=${query}`)
}

export function getDepartmentAssetList(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/users/department-assets/?${fparam}`);
}
export function getDepartmentAssetListExport(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/users/department-assets/?${fparam}`, {
    responseType: "blob",
  });
}